import React from 'react';
import { X } from 'lucide-react';
import ModalMessage from '../../UI/organisms/ModalMessage';
import ForgotPassword from '../../Auth/ForgotPassword';
import { withTranslation } from 'next-i18next';
import { Card, CardHeader, CardTitle, CardContent } from '@lb-classroom/ui';

interface ForgotPasswordModalContentProps {
  t: (key: string, options?: Record<string, unknown>) => string;
  message?: string;
  messageType?: string;
  hideModal: () => void;
  clearModalMessage: () => void;
}

const ForgotPasswordModalContent = (props: ForgotPasswordModalContentProps) => {
  const { t, message, messageType, hideModal, clearModalMessage } = props;
  return (
    <div className="max-w-sm mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('links.resetPassword')}</CardTitle>
          <button type="button" className="modal-close" onClick={hideModal}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <ForgotPassword
            inModal={true}
            clearModalMessage={clearModalMessage}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default withTranslation('common')(ForgotPasswordModalContent);
